import React from "react";
import { NavLink } from "react-router-dom";
import { AppData } from "../../types";
import backupAppImg from "../../assets/imgs/shop-icon.png";

type AppButtonProps = {
  data: AppData;
  className?: string;
};

export const AppButton = ({ data, className = "" }: AppButtonProps) => {
  const baseClassname = "app-button";

  return (
    <NavLink
      className={`${baseClassname} ${className}`}
      to={`/apps/${data.id}`}
    >
      <img
        className={`${baseClassname}__img`}
        src={backupAppImg}
        alt={`${data.name} app icon.`}
      />
      <span>{data.name}</span>
    </NavLink>
  );
};
